export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-capsule-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const faqs = [
  {
    question: 'What is Superbuy Sheet?',
    answer: 'Superbuy Sheet is an organized collection of product information, links, categories, and research data that helps international shoppers discover and compare products more efficiently. It aggregates curated product data so you can make smarter buying decisions without spending hours searching through endless listings.',
  },
  {
    question: 'Is Superbuy Sheet free to use?',
    answer: 'Yes, all the Superbuy Sheet resources and guides on this website are completely free. We are an independent educational platform dedicated to helping shoppers find better products. Simply browse our categories, explore our guides, and use the links to discover products on the main platform.',
  },
  {
    question: 'How do I use Superbuy Sheet?',
    answer: 'Using Superbuy Sheet is straightforward. First, choose a product category from our dropdown menu or category grid. You will be taken to the main platform where organized product collections await. Browse the curated selections, compare different options, and use the structured information to make informed purchasing decisions.',
  },
  {
    question: 'Is Superbuy Sheet safe to use?',
    answer: 'Absolutely. We are an independent educational and research website. We do not sell products directly, process payments, or store any personal information. All links redirect you to the official platform where standard security measures are in place. We always recommend verifying product details before making any purchase.',
  },
  {
    question: 'Where can I find updated Superbuy Sheet resources?',
    answer: 'This website is regularly updated with the latest Superbuy Sheet resources, category collections, and shopping guides. Bookmark our homepage and check back frequently for new content. You can also use our category navigation to find the most current product collections organized by type.',
  },
  {
    question: 'How often are the category collections updated?',
    answer: 'Our category collections are refreshed regularly to ensure you have access to the latest product information. We monitor trending products, update category links, and add new resources to help you stay ahead of the curve in international shopping.',
  },
];

export const benefits = [
  {
    title: 'Save Research Time',
    description: 'Skip hours of manual searching. Our organized Superbuy Sheet collections put curated products at your fingertips so you can find what you need in minutes, not days.',
    icon: 'ri-time-line',
  },
  {
    title: 'Compare Products Easily',
    description: 'Side-by-side product comparisons made simple. Our structured format lets you evaluate options across multiple dimensions before making a decision.',
    icon: 'ri-scales-line',
  },
  {
    title: 'Discover Trending Items',
    description: 'Stay ahead of the curve with curated collections of trending products. Our Superbuy Sheet resources highlight what is popular right now across every category.',
    icon: 'ri-fire-line',
  },
  {
    title: 'Understand QC Photos',
    description: 'Learn how to interpret quality control photos and product inspection reports. Our guides help you understand what to look for before confirming your order.',
    icon: 'ri-image-line',
  },
  {
    title: 'Plan Purchases Better',
    description: 'Strategic shopping with organized information. Build your haul systematically using our category breakdowns and product comparison resources.',
    icon: 'ri-calendar-check-line',
  },
];

export const howItWorks = [
  {
    step: 1,
    title: 'Choose Category',
    description: 'Browse our comprehensive category list or use the dropdown menu to find the product type you are interested in exploring.',
    icon: 'ri-file-list-line',
  },
  {
    step: 2,
    title: 'Compare Products',
    description: 'Access the organized product collections on the main platform. Review curated selections with structured product information and pricing details.',
    icon: 'ri-file-search-line',
  },
  {
    step: 3,
    title: 'Review QC Information',
    description: 'Check quality control photos, product specifications, and seller ratings before making your decision. Understand exactly what you are getting.',
    icon: 'ri-zoom-in-line',
  },
  {
    step: 4,
    title: 'Make Better Decisions',
    description: 'With all the organized information at your fingertips, confidently choose the best products that match your needs and budget.',
    icon: 'ri-check-double-line',
  },
];